module.exports = {
  OpenDevStorage: process.env.VUE_APP_ENV !== 'production'
}
